import React, { useEffect, useLayoutEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import Header from './Constans/Header';
import StepBar from './Constans//StepBar';
import {
  setStep,
  goToPage,
  setSelectedPackage,
  saveToHistory,
  pushToHistory,
  setLineType,
  setLineNumber,
  setPersonalInfoMode,
  setSelectedAddress,
  setSelectedEmail,
  setSelectedPhoneNumber,
  setConfirmMail,
  setMailbox,
  setPostalCode,
  setDeliveryMode,
  setIsUsePersonalInfoAddress,
  setIsSimInMailBox,
  setDeliverySelectedFullName,
  setDeliveryComments,
  setDeliverySelectedPhoneNumber,
  setDeliverySelectedAddress,
  setPickupServiceCenter,
  setDataTransfer,
  setDataTransferName,
  setAcceptDataDownload,
  setSubAgreement,
  setAcceptTerms,
  setSignNameTerms,
  setIHaveSignedWillingly,
  setSignNameWilling,
  setAcceptSecurity,
  setAcceptAuction,
  setIsJoiningFormValid,
  setSelectedPhone,
  setProcessType,
  setIsLeasing,
  setIsShowHeader,
  setDeliverySlot,
  setSimType,
  setIsShowAuction,
  setIsShowSecurityForm,
  InsertOrderDetails,
  InsertOrderDetailsPhoneUpgrade,
  GetUserDetails,
  GetDeliverySlotsByAdress,
  GetCitiesServiceCenters,
  setCurrentStep,
  setFeatureList,
  clearHistory,
  setCreditDecision
} from './IdfSaleSlice';
import PlanSelection from './SaleSteps/PlanSelection';
import DeviceSelection from './SaleSteps/DeviceSelection';
import DeliveryDateMain from './SaleSteps/DeliveryDateMain';
import OrderSummary from './SaleSteps/OrderSummary';
import OrderSummaryPhoneUpgrade from './SaleSteps/OrderSummaryPhoneUpgrade';
import PersonalInfoMain from './SaleSteps/PersonalInfoMain';
import { convertPackageTitle, getPage, isNoDeliveryProccess, planSelectionRadioEnums, steps, PathHistory } from './IdfSaleEnums';
import useEffectAsync from '../../../utilities/hooks/useEffectAsync';
import EsimPopUp from './PopUps/EsimPopUp';
import PopUp from '../../Shared/Popup/PopUp';
import EsimStrip from './Constans/EsimStrip';
import EpiContext from "@episerver/spa-core/Spa";
import Config from 'app/Config'
import {
  dwhRepPurchaseForSoldier,
  dwhRepPurchaseNiudForSoldier,
  dwhRepUpgradeForSoldier
} from "app/Components/Block/IdfSaleBlock/dwhReports/dwhReports";
import DeliveryDateStepOne from './SaleSteps/DeliveryDateStepOne';
import DeliveryDateStepTwo from './SaleSteps/DeliveryDateStepTwo';
import PersonalInfoStepOne from './SaleSteps/PersonalInfoStepOne';
import PersonalInfoStepTwo from './SaleSteps/PersonalInfoStepTwo';
import { ROLE_TYPE } from '../IdfMainPageBlock/IdfMainPageEnum';
import { refreshToken } from '../../../utilities/authentication/authenticationSlice';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import { isNullOrEmpty } from 'app/utilities/StringHelpers/StringHelpers';
import { dwhReport, dwhDictionary } from './dwhReports/dwhGeneralReport';

export const IdfSale = (props) => {
  const store = props.idfStore;
  const RoleList = props.auth.loginData?.userDetails?.RoleList;
  const isIDFCustomer = RoleList?.some(role => role.startsWith('IDFOTP')) ?? false;
  const [refreshedToken, setRefreshedToken] = useState(false);
  useLayoutEffect(() => {
    if (props.auth.loginData?.isFullAuthenticated) {
      if (!isIDFCustomer) {
        EpiContext.navigateTo(Config.lobbyUrl)
      }
    }
  }, []);

  useEffectAsync(async () => {
    if (isIDFCustomer) {
      if (props.auth.loginData?.isFullAuthenticated && isNullOrEmpty(store.userDetails)) {
        const res = await props.GetUserDetails();
      }
      if (RoleList?.some(role => role != ROLE_TYPE.IDFOTP_NEWCUSTOMER) && !props.idfStore.deviceUpgradeProcessing && store.steps.current != PathHistory.OrderSummary) {
        EpiContext.navigateTo(Config.idfHomePageUrl)
      }
    } else if (!props.auth.loginData?.isFullAuthenticated) {
      EpiContext.navigateTo(Config.idfLoginUrl)
    }
  }, [props.auth?.loginData?.isFullAuthenticated]);


  useEffect(() => {
    window.scrollTo(0, 0);
  }, [store.steps.current]);

  useEffect(() => {
    const handlePopstate = () => {
      if ((store?.steps?.current == PathHistory.DeviceSelectionStep1 && props.idfStore?.deviceUpgradeProcessing) || (
        RoleList?.some(role => role != ROLE_TYPE.IDFOTP_NEWCUSTOMER) && window.location.hash.split("#")[1] == PathHistory.OrderSummary && !props.idfStore?.deviceUpgradeProcessing
      )) {
        EpiContext.navigateTo(Config.idfHomePageUrl);
      }
    };
    window.addEventListener('popstate', handlePopstate);
    return () => {
      window.removeEventListener('popstate', handlePopstate);
    };
  }, []);

  const onFinalSubmit = async () => {
    let deliveryMode;
    orderSummaryDwh()
    if (store?.deliveryMode == 'PICKUP') deliveryMode = 2;
    if (store?.deliveryMode == 'DELIVERY') deliveryMode = 3;

    const OrderDetails = {
      //#region PLAN SELECTION
      // internetPackageSocId: 1, // Soc Id
      internetPackageSocId: store.selectedPackage?.addons?.[0]?.id?.value || '', // Soc Id
      internetPackagePrice: store.selectedPackage?.price,
      internetPackageName: convertPackageTitle(store.selectedPackage.title),
      warrentyPrice: props.contentData.warrantyPrice?.value || '0',
      phoneInsertType: store?.lineType,
      phoneInsertNumber: store?.lineNumber,
      simType: store.simType === 'eSIM' ? 1 : 0,

      //#endregion
      //#region PERSONAL INFO STEP ONE
      // ADDRESS MODE
      personalAddress: {
        cityCode: store.selectedAddress?.cityCode ?? '',
        streetCode: store.selectedAddress?.streetCode ?? '',
        streetName: store.selectedAddress?.streetName ?? '',
        cityName: store.selectedAddress?.cityName ?? '',
        houseNo: store.selectedAddress?.home ?? '',
        houseEntrance: store.selectedAddress?.entry ?? '',
        zipCode: store.personalInfoMode == 'MAILBOX' ? store.postalCode : store.selectedAddress.zipCode,
        addressAptNo: store.selectedAddress?.apartment ? parseFloat(store.selectedAddress?.apartment) : 0,
        poBox: store?.mailbox ?? '',
      },
      userId: '',
      telephoneNo: store?.selectedPhoneNumber, // להוסיף את הקו שצהל נותן
      email: store?.selectedEmail,
      sendInvoicesToEmail: store?.confirmMail,
      //#endregion
      //#region PERSONAL INFO STEP TWO
      // CREDIT CARD TBD
      paymentTypeId: store?.selectedPhone?.paymentType === 'INVOICE' ? 1 : 2, // מחוץ לחשבונית או לא
      numPayments: store?.selectedPhone?.selectedPayment ?? '1',
      creditCardTypeId: props.paymentCg?.CGData?.ccType ?? '',
      creditCardMonth: props.paymentCg?.CGData?.cardMonth ?? '',
      creditCardYear: props.paymentCg?.CGData?.cardYear ?? '',
      creditCardToken: props.paymentCg?.CGData?.ccToken ?? '',
      creditCardIdNumber: props.paymentCg?.CGData?.id ?? '',
      bankCode: null ?? '',
      bankBranchCode: null ?? '',
      bankAccountNo: null ?? '',
      // END CREDIT CARD
      // CAVITIES FORM
      equipmentUserForm: {
        signatureData: store?.joiningForm,
        acceptSecurity: store?.acceptSecurity,
        acceptAuction: store?.acceptAuction,
      },

      // END CAVITIES FORM
      serviceAccessForm: store?.serviceAccessForm,

      //#endregion
      //#region DEVICE SELECTION
      orderModel: {
        phoneModelId: store?.selectedPhone?.modelId || '0',
        isPhoneModelUpgraded: false,
        itemId: store?.selectedPhone?.item_id || '',
        matNr: store?.selectedPhone?.rcpmat || '',
        pricePlan: store?.selectedPackage?.blockID || '',
        packageCode: '',
        hierarchyLevel: '',
        combSeq: '',
        upgradeCourse: '',
        matNrColor: '',
        isLeasing: store.isLeasing || false,
        color: store?.selectedPhone?.selectedColor || '',
        size: '',
        payMentCount: '',
        payMentCountInt: 0,
        genInfoSoc: '',
        socPrice: '',
        isSim: true,
        modelImage: '',
        modelName: store?.selectedPhone?.groupName,
        modelPrice: store?.selectedPhone?.totalPrice,
        paymentType: '',
        isInterestedInWarranty: store?.selectedPhone?.insuranceOption === 'ADD_INSURANCE' || false,
        warrantyInd: '',
      },
      handsfreeModelId: null,
      isHandsfreeModelUpgraded: false,
      //#endregion
      //#region DELIVERY DATE
      deliveryTypeId: deliveryMode,
      deliveryAddress: {
        deliveryStartTime: store.selectedDeliverySlot.deliveryStartTime ?? null,
        deliveryEndTime: store.selectedDeliverySlot.deliveryEndTime ?? null,
        hebrewDayName: store.selectedDeliverySlot.hebrewDayName ?? null,
        round: store.selectedDeliverySlot.round ?? null,
        deliveryCityCode: store.deliverySelectedAddress?.cityCode ?? '',
        deliveryStreetCode: store.deliverySelectedAddress?.streetCode ?? '',
        deliveryStreetName: store.deliverySelectedAddress?.streetName ?? '',
        deliveryCityName: store.deliverySelectedAddress?.cityName ?? '',
        deliveryHouseNo: store.deliverySelectedAddress?.home ?? '',
        deliveryHouseEntrance: store.deliverySelectedAddress?.entry ?? '',
        deliveryAddressAptNo: store.deliverySelectedAddress?.apartment ?? '',
        deliveryZipCode: store.deliverySelectedAddress?.zipCode ?? 0,
        deliveryPoBox: store?.mailbox ?? '',
        deliveryReceiverName: store.deliverySelectedFirstName + ' ' + store.deliverySelectedLastName,
        deliveryReceiverPhone: store.deliverySelectedPhoneNumber,
        deliveryNotes: store?.deliveryComments,
        deliveryLocationId: store.selectedDeliverySlot.deliveryLocationId,
      },


      pickUpDetails: {
        // isCourierDelivery: false,
        pickupAppointmentEnd: 'null',
        pickupDatetime: '2023-10-25T10:29:29.743Z',
        pickupDistributionCenterAddress: store?.pickupServiceCenter?.service_center_location || '',
        pickupDistributionCenterId: '', //store?.pickupServiceCenter?.service_center_id || '',
        pickupDistributionCenterName: store?.pickupServiceCenter?.service_center_name || '',
        pickupAppointmentId: store?.pickupServiceCenter?.service_center_id || '',
      },

      //#endregion
      //#region ORDER SUMMERY
      isInterestedInAdditionalOffers: false,
      // דואר אלקטרוני לסיכום הזמנה
      serialNumber: '',
      creditDecision: store.creditDecision,
      //#endregion
    };
    try {
      const res = await props.InsertOrderDetails(OrderDetails);
      if (res.payload.isSuccess) {
        refreshTokenAfterProcessSucceeded();
        const repId = store?.repId;
        if (repId) {
          if (store.lineType === 3) {
            dwhRepPurchaseNiudForSoldier(repId, store?.userDetails?.id_number, getCustomerNewNumber(), store?.userDetails?.first_name + " " + store?.userDetails?.last_name, store?.userDetails?.transaction_id);
          } else {
            dwhRepPurchaseForSoldier(repId, store?.userDetails?.id_number, getCustomerNewNumber(), store?.userDetails?.first_name + " " + store?.userDetails?.last_name, store?.userDetails?.transaction_id);
          }
        }
      }

      return res;
    } catch (error) {
      console.log(error);
    }
  };
  const onUpgradeDeviceFinalSubmit = async () => {
    orderSummaryDwh()
    const store = props.idfStore;
    let deliveryMode;
    if (store?.deliveryMode == 'PICKUP') deliveryMode = 2;
    if (store?.deliveryMode == 'DELIVERY') deliveryMode = 3;
    const orderDetails = {
      numPayments: store.selectedPhone.selectedPayment ?? '1',
      internetPackageSocId: '',
      deliveryAddress: {
        deliveryAddressAptNo: store.deliverySelectedAddress?.apartment ?? '',
        deliveryCityCode: store.deliverySelectedAddress?.cityCode ?? '',
        deliveryCityName: store.deliverySelectedAddress?.cityName ?? '',
        deliveryEndTime: store.selectedDeliverySlot.deliveryEndTime ?? null,
        deliveryHouseEntrance: store.deliverySelectedAddress?.entry ?? '',
        deliveryHouseNo: store.deliverySelectedAddress?.home ?? '',
        deliveryLocationId: store.selectedDeliverySlot.deliveryLocationId,
        deliveryNotes: store.deliveryComments,
        deliveryPoBox: store?.mailbox ?? '',
        deliveryReceiverName: `${store.deliverySelectedFirstName} ${store.deliverySelectedLastName}`,
        deliveryReceiverPhone: store.deliverySelectedPhoneNumber,
        deliveryStartTime: store.selectedDeliverySlot.deliveryStartTime ?? null,
        deliveryStreetCode: store.deliverySelectedAddress?.streetCode ?? '',
        deliveryStreetName: store.deliverySelectedAddress?.streetName ?? '',
        deliveryZipCode: store.deliverySelectedAddress?.zipCode ?? 0,
        hebrewDayName: store.selectedDeliverySlot.hebrewDayName ?? null,
        round: store.selectedDeliverySlot.round ?? null,
      },
      deliveryTypeId: deliveryMode,
      email: store?.selectedEmail,
      isHandsfreeModelUpgraded: false,
      isInterestedInAdditionalOffers: false,
      orderModel: {
        color: store?.selectedPhone?.selectedColor || '',
        isInterestedInWarranty: store?.selectedPhone?.insuranceOption === 'ADD_INSURANCE' || false,
        isLeasing: store.isLeasing || false,
        isPhoneModelUpgraded: store?.selectedPhone.paymentType === 'INVOICE',
        isSim: false,
        itemId: store?.selectedPhone?.item_id || '',
        matNr: store?.selectedPhone?.rcpmat || '',
        modelName: store?.selectedPhone?.groupName,
        modelPrice: store?.selectedPhone?.totalPrice,
        monthlyPrice: parseFloat((store.selectedPhone.totalPrice / parseInt(store.selectedPhone.selectedPayment, 10)).toFixed(2)),
        payMentCount: '',
        payMentCountInt: 0,
        payMentType: '',
        phoneModelId: store?.selectedPhone?.modelId || '0',
        warrantyInd: '',
      },
      phoneInsertNumber: 0,
      pickUpDetails: {
        pickupAppointmentEnd: '',
        pickupDatetime: '',
        pickupDistributionCenterAddress: store?.pickupServiceCenter?.service_center_location || '',
        pickupDistributionCenterId: '', //store?.pickupServiceCenter?.service_center_id || '',
        pickupDistributionCenterName: store?.pickupServiceCenter?.service_center_name || '',
        pickupAppointmentId: store?.pickupServiceCenter?.service_center_id || '',
      },
      serviceAccessForm: store?.serviceAccessForm,
      warrentyPrice: props.contentData.warrantyPrice?.value || '0',
      personalAddress: {
        cityCode: store.selectedAddress?.cityCode ?? '',
        streetCode: store.selectedAddress?.streetCode ?? '',
        streetName: store.selectedAddress?.streetName ?? '',
        cityName: store.selectedAddress?.cityName ?? '',
        houseNo: store.selectedAddress?.home ?? '',
        houseEntrance: store.selectedAddress?.entry ?? '',
        zipCode: 0,
        addressAptNo: store.selectedAddress?.apartment ? parseFloat(store.selectedAddress?.apartment) : 0,
        poBox: store?.mailbox ?? '',
      },
    };
    try {
      const res = await props.InsertOrderDetailsPhoneUpgrade(orderDetails);
      if (res.payload.isSuccess) {
        refreshTokenAfterProcessSucceeded();
        const repId = store?.repId;
        if (repId) {
          dwhRepUpgradeForSoldier(repId, store?.userDetails?.id_number, getCustomerNewNumber(), store?.userDetails?.first_name + " " + store?.userDetails?.last_name, store?.userDetails?.transaction_id);
        }
      }
      return res;
    } catch (error) {
      console.log(error);
    }
  };


  const refreshTokenAfterProcessSucceeded = async () => {
    props.setIsShowHeader(false);
    props.showAppLoader();
    const response = await props.refreshToken();
    await props.GetUserDetails();
    props.hideAppLoader();
  }

  const orderSummaryDwh = () => {
    dwhReport({
      ...dwhDictionary.OrderConfirmation_Completed,
      param4: store.isLeasing,
      param5: store.simType,
      param6: store.processType == "DEVICE" ? 'עם מכשיר' : 'ללא מכשיר',
      param7: store.deliveryMode,
      param8: store.deliveryMode == "PICKUP" ? store.pickupDate : store.selectedDeliverySlot.deliveryStartTime,
      param10: store?.selectedEmail
    });
  }

  const getCurrentStep = () => {
    switch (store.steps.current) {
      case PathHistory.PlanSelection:
        return <PlanSelection />;
      case PathHistory.PersonalInfo:
        return <PersonalInfoStepOne />;
      case PathHistory.PaymentInfo:
        return <PersonalInfoStepTwo />;
      case PathHistory.DeviceSelectionStep1:
        return <DeviceSelection />;
      case PathHistory.DeviceSelectionStep2:
        return <DeviceSelection setInnerStep={store.processType === 'DEVICE'} />;
      case PathHistory.DeliveryDateStep1:
        return <DeliveryDateStepOne />;
      case PathHistory.DeliveryDateStep2:
        return <DeliveryDateStepTwo />;
      case PathHistory.OrderSummary:
        return !store.deviceUpgradeProcessing ? (
          <OrderSummary onFinalSubmit={onFinalSubmit} />
        ) : (
          <OrderSummaryPhoneUpgrade onFinalSubmit={onUpgradeDeviceFinalSubmit} />
        );
      default:
        return <PlanSelection />;
    }
  }


  const getCurrentSaleStep = () => {
    var currentPath = window.location.href.split('#')[1];
    if (store.steps.current !== currentPath) {
      props.pushToHistory(store.steps.current)
    }
    const currentComponent = getCurrentStep();
    return currentComponent ? React.cloneElement(currentComponent, { ...props }) : null;

  };

  function getCustomerNewNumber() {
    let customerNewNumber;
    if (store.lineType == 1) return '0' + store.userDetails.new_line_code;
    if (store.lineType != 1) return store.lineNumber;
  }

  return (
    <div className='idf-sale-main'>
      <div className='idf-fixed'>
        <Header {...props} />
        {props.idfStore.isShowHeader && (
          <>
            <StepBar {...props} />
          </>
        )}
        {store.simType === 'eSIM' && store.steps.current !== PathHistory.OrderSummary && (
          <EsimStrip processType={props.idfStore.processType} />
        )}
      </div>
      <div className={`idf-generic-component ${store.simType === 'eSIM' && store.steps.current !== PathHistory.OrderSummary ? 'strip-visible' : ''}`}></div>
      {getCurrentSaleStep()}
    </div>
  );
};

const mapStateToProps = (state) => ({
  idfStore: state.idfSale,
  paymentCg: state.PaymentCG,
  auth: state.authentication,
});

const mapDispatchToProps = {
  setStep,
  goToPage,
  setSelectedPackage,
  saveToHistory,
  pushToHistory,
  setLineType,
  setLineNumber,
  setPersonalInfoMode,
  setSelectedAddress,
  setSelectedEmail,
  setSelectedPhoneNumber,
  setConfirmMail,
  setMailbox,
  setPostalCode,
  setDeliveryMode,
  setIsUsePersonalInfoAddress,
  setIsSimInMailBox,
  setDeliverySelectedFullName,
  setDeliverySelectedPhoneNumber,
  setDeliveryComments,
  setDeliverySelectedAddress,
  setPickupServiceCenter,
  setDataTransfer,
  setDataTransferName,
  setAcceptDataDownload,
  setSubAgreement,
  setAcceptTerms,
  setSignNameTerms,
  setIHaveSignedWillingly,
  setSignNameWilling,
  setAcceptSecurity,
  setAcceptAuction,
  setIsShowAuction,
  setIsShowSecurityForm,
  setSelectedPhone,
  setIsJoiningFormValid,
  setProcessType,
  setIsShowHeader,
  setIsLeasing,
  setDeliverySlot,
  InsertOrderDetails,
  InsertOrderDetailsPhoneUpgrade,
  GetUserDetails,
  setSimType,
  GetDeliverySlotsByAdress,
  GetCitiesServiceCenters,
  setCurrentStep,
  setFeatureList,
  refreshToken,
  clearHistory,
  hideAppLoader,
  showAppLoader,
  setCreditDecision
};

export default connect(mapStateToProps, mapDispatchToProps)(IdfSale);
